import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { TableContent } from '../../../../../../../components/TableContent';
import { AddedProductItemList } from '../../../../../utils/types';
import { LateralBar } from '../../../../DynamicAsset/components/Asset/components/LateralBar';
import { InvalidProductItem } from '../Invalid';

interface AddedProductItemContainerProps {
  lateralBarBackgroundColor: string;
  isInvalid: boolean;
  data: AddedProductItemList;
  children: React.ReactNode;
  orderIsRecused: boolean;
}

export const AddedProductItemContainer: React.FC<AddedProductItemContainerProps> = ({
  lateralBarBackgroundColor,
  isInvalid,
  data,
  children: layout,
  orderIsRecused,
}) => {
  const invalidTableContentStyles = isInvalid && {
    p: 0,
    pb: Spacing['inline.xxs'],
    px: Spacing['inline.xxs'],
  };

  return (
    <TableContent
      space={Spacing['inline.xxxs']}
      direction="column"
      bg={Utils.ColorToken.WithOpacity('background', 1)}
      {...invalidTableContentStyles}>
      <LateralBar
        backgroundColor={lateralBarBackgroundColor}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      {isInvalid && <InvalidProductItem data={data as AddedProductItemList} />}
      {!orderIsRecused && layout}
    </TableContent>
  );
};
